import { spaceCadet } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  gap: 32,
  '& > .MuiBox-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& > .MuiBox-root.user': {
      display: 'flex',
      gap: 4,

      '& .MuiAvatar-root': {
        fontSize: 14,
        width: 24,
        height: 24,
      },
      '& svg': {
        width: 24,
        height: 24,
        display: 'block',
        color: spaceCadet[400],
      },

      '& .MuiTypography-body1': {
        marginTop: 0,
        fontWeight: 600,
      },
    },
    '& .MuiTypography-subtitle2': {
      color: spaceCadet[400],
      fontSize: 14,
      lineHeight: '16px',
    },
  },

});

export default StyledBox;
